"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CategoriesSection = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireDefault(require("react"));
var _Title = require("../Title");
var _constants = require("./constants");
var _parseCategories = require("./parseCategories");
var _styles = require("./styles");
var _useCarouselOptions = require("./useCarouselOptions");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Returns section with `CategoryBox` `Carousel` and `Title`.
 * Renders if there is at least 1 category with thruthy data.
 */ const CategoriesSection = (param)=>{
    let { categories, className, title, viewButtonText } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const isMobile = (0, _presentationHooks.useIsMobile)();
    const parsedCategories = (0, _parseCategories.parseCategories)({
        categories
    });
    const numberOfSlides = parsedCategories.length;
    const options = (0, _useCarouselOptions.useCarouselOptions)();
    if (numberOfSlides < 1) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        className: className,
        "data-testid": getTestId(_constants.CATEGORIES_SECTION),
        numberOfSlides: numberOfSlides,
        children: [
            title ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Title.Title, {
                title: title
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Carousel, {
                ...options,
                id: "editorials-categories-section-carousel",
                children: parsedCategories.map((param)=>{
                    let { imageUrl, relativeUrl, title: categoryTitle } = param;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.CarouselSlide, {
                        minWidth: isMobile ? _presentationComponents.CATEGORY_BOX_MOBILE_WIDTH : _presentationComponents.CATEGORY_BOX_DESKTOP_WIDTH,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.CategoryBox, {
                            buttonText: viewButtonText,
                            imageUrl: imageUrl,
                            relativeUrl: relativeUrl,
                            title: categoryTitle
                        })
                    }, relativeUrl);
                })
            })
        ]
    });
};
exports.CategoriesSection = CategoriesSection;
